import { IController } from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';
import { ActiveSupportCategories } from '../../../../../../ng2/shared/constants/support-categories.constant';

export class ConfirmStepCtrl implements IController {
  static $inject = ['$scope', 'ImUser'];

  // Bindings
  private currentSupport;
  private supportCategories;
  private saveSupport;

  constructor(private $scope, private imUser: ImUser) {}

  $onInit() {
    this.supportCategories = ActiveSupportCategories;
  }

  // Functions
  constructConfirmationSummary = currentSupport => {
    const { startTime, endTime } = currentSupport.schedule;
    if (startTime && endTime) {
      if (currentSupport.schedule.repeats === 'NONE') {
        return (
          'On ' +
          moment(currentSupport.schedule.startsOn).format('M/DD/YY') +
          ' from ' +
          currentSupport.schedule.startTime +
          ' to ' +
          currentSupport.schedule.endTime
        );
      } else {
        return (
          _.capitalize(currentSupport.schedule.repeats.toLowerCase()) +
          ' from ' +
          currentSupport.schedule.startTime +
          ' to ' +
          currentSupport.schedule.endTime +
          ' from ' +
          moment(currentSupport.schedule.startsOn).format('M/DD/YY') +
          ' to ' +
          moment(currentSupport.schedule.endsOn).format('M/DD/YY')
        );
      }
    } else return `Date and Time are required`;
  };

  isValidSupport = support => {
    return (
      support.name &&
      support.description &&
      support.category &&
      support.activityLead &&
      support.schedule.startsOn &&
      support.schedule.startTime &&
      support.schedule.endsOn &&
      support.schedule.endTime
    );
  };

  updateSupport = () => {
    this.$scope.currentSupport = this.currentSupport;
    this.saveSupport();
  };
}

angular.module('nv.SupportsModule').controller('confirmStepCtrl', ConfirmStepCtrl);
